export function downloadByUrl(url, fileName) {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a');
  // if(!!fileName) eleLink.download = fileName;
  eleLink.download = url
  eleLink.style.display = 'none';
  eleLink.href = url;
  eleLink.target = "__brank"
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
}
